export default __webpack_public_path__ + "static/media/lm.006.4863d0cc.png";